import { useState } from "react";

const Features = ({ service }) => {
  const direction = service.reverse ? "sm:flex-row-reverse" : "sm:flex-row";
  const bgColor = service.bgColor
    ? { backgroundColor: "rgba(36, 132, 147, 0.15)" }
    : { backgroundColor: "#FFFFFF" };

  const [expanded, setExpanded] = useState(false);
  const hasList = service.list && service.list.length > 0;

  return (
    <div style={bgColor}>
      <div
        className={`flex flex-col ${direction} items-center justify-center py-[50px] px-[20px] sm:p-[100px] sm:gap-[20px] lg:gap-[50px]`}
      >
        <div className="sm:w-[476px] font-poppins text-center sm:text-left">
          <p className="text-2xl lg:text-level-2 xl:text-4xl text-[#F6867A] font-semibold">
            {service.title}
          </p>
          <p className="text-level-6 lg:text-[22px] xl:text-[25px] text-green font-semibold mt-2 mb-4">
            {service.subtitle}
          </p>

          <div className="text-[#6A6868] font-light text-justify">
            <p className=" text-level-7 lg:text-lg xl:text-xl">
              {service.description}
            </p>
          </div>

          {expanded && (
            <div className="text-[#6A6868] font-light text-level-7 lg:text-lg xl:text-xl text-justify">
              {service.additionalPara1 && (
                <p className="mt-4"> {service.additionalPara1} </p>
              )}

              {service.additionalPara2 && (
                <p className="mt-4"> {service.additionalPara2} </p>
              )}

              <p className="mb-2 mt-4">{service.listHeader}</p>
              <ul className="list-disc pl-2">
                {service.list.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {hasList && (
            <button
              className="bg-[#F6867A] text-white-text text-level-7 lg:text-level-5 font-semibold w-[127px] h-[40px] lg:w-[143px] lg:h-[48px] rounded-xl mt-10"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Read Less" : "Read More"}
            </button>
          )}
        </div>

        <div className="w-full h-[250px] md:w-[280px] lg:w-[346px] lg:h-[329px] xl:w-[714px] xl:h-[510px] overflow-hidden rounded-xl mt-[50px] sm:mt-0 ">
          <img
            src={service.image}
            alt="servicesImages"
            className="w-full h-full object-cover object-top "
          />
        </div>
      </div>
    </div>
  );
};
export default Features;
